<template>
  <div class="menu-box bgff">
    <div class="menu">
      <div
        v-for="(item, index) in menuList"
        :key="index"
        :class="{
          'menu-click': item.path == $route.path || item.path == $route.meta.menu,
          }"
        class="inner cursor"
        @click="linkGo(item, index)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
// import { apiHome } from "@/api/apiHome"
import localStorage from "@/storage/localStorage"
export default {
  name: "Menu",
  data() {
    return {
      indexKey: -1,
      routerName: "home",
      menuList: [
        {
          isClick: false,
          createTime: 1552969596742,
          createUser: 10,
          icon: "material/650000/20190926718214268542593.png",
          id: 10,
          name: "首页",
          routerName: "home",
          no: "Allmerchandise",
          pcUrl: "https://dev.gcw.net",
          remember_me: "",
          sort: 1,
          updateTime: 1566471530453,
          updateUser: 81,
          wapUrl: "https://wap.gcw.net",
          path: "/"
        },
        {
          isClick: false,
          createTime: 1552969596742,
          createUser: 10,
          icon: "material/650000/20190926718214268542593.png",
          id: 10,
          name: "工程工队",
          routerName: "TeamList",
          no: "Allmerchandise",
          pcUrl: "https://dev.gcw.net",
          remember_me: "",
          sort: 1,
          updateTime: 1566471530453,
          updateUser: 81,
          wapUrl: "https://wap.gcw.net",
          path: "/teamList"
        },
        {
          isClick: false,
          createTime: 1552969596742,
          createUser: 10,
          icon: "material/650000/20190926718214268542593.png",
          id: 10,
          name: "专业工人",
          routerName: "worker",
          no: "Allmerchandise",
          pcUrl: "https://dev.gcw.net",
          remember_me: "",
          sort: 1,
          updateTime: 1566471530453,
          updateUser: 81,
          wapUrl: "https://wap.gcw.net",
          path: "/worker"
        },
        {
          isClick: false,
          createTime: 1552969596742,
          createUser: 10,
          icon: "material/650000/20190926718214268542593.png",
          id: 10,
          name: "工种报价",
          routerName: "VolunteerTeamOffer",
          no: "Allmerchandise",
          pcUrl: "https://dev.gcw.net",
          remember_me: "",
          sort: 1,
          updateTime: 1566471530453,
          updateUser: 81,
          wapUrl: "https://wap.gcw.net",
          path: "/volunteerTeamOffer"
        },
        {
          isClick: false,
          createTime: 1552969596742,
          createUser: 10,
          icon: "material/650000/20190926718214268542593.png",
          id: 10,
          name: "劳务用工",
          routerName: "labour",
          no: "Allmerchandise",
          pcUrl: "https://dev.gcw.net",
          remember_me: "",
          sort: 1,
          updateTime: 1566471530453,
          updateUser: 81,
          wapUrl: "https://wap.gcw.net",
          path: "/labour"
        },
        {
          isClick: false,
          createTime: 1552969596742,
          createUser: 10,
          icon: "material/650000/20190926718214268542593.png",
          id: 10,
          name: "临时用工",
          routerName: "FlexibleEmployment",
          no: "Allmerchandise",
          pcUrl: "https://dev.gcw.net",
          remember_me: "",
          sort: 1,
          updateTime: 1566471530453,
          updateUser: 81,
          wapUrl: "https://wap.gcw.net",
          path: "/FlexibleEmployment"
        },
        {
          isClick: false,
          createTime: 1552969596742,
          createUser: 10,
          icon: "material/650000/20190926718214268542593.png",
          id: 10,
          name: "工程分包",
          routerName: "Zb",
          no: "Allmerchandise",
          pcUrl: "https://dev.gcw.net",
          remember_me: "",
          sort: 1,
          updateTime: 1566471530453,
          updateUser: 81,
          wapUrl: "https://wap.gcw.net",
          path: "/zb"
        },
        {
          isClick: false,
          createTime: 1552969596742,
          createUser: 10,
          icon: "material/650000/20190926718214268542593.png",
          id: 10,
          name: "劳务公司",
          routerName: "LaborServiceCompany",
          no: "Allmerchandise",
          pcUrl: "https://dev.gcw.net",
          remember_me: "",
          sort: 1,
          updateTime: 1566471530453,
          updateUser: 81,
          wapUrl: "https://wap.gcw.net",
          path: "/LaborServiceCompany"
        },
        {
          isClick: false,
          createTime: 1552969596742,
          createUser: 10,
          icon: "material/650000/20190926718214268542593.png",
          id: 10,
          name: "人气工队",
          routerName: "popularityTeam",
          no: "Allmerchandise",
          pcUrl: "https://dev.gcw.net",
          remember_me: "",
          sort: 1,
          updateTime: 1566471530453,
          updateUser: 81,
          wapUrl: "https://wap.gcw.net",
          path: "/popularityTeam"
        }
        // {
        //   isClick: false,
        //   createTime: 1552969596742,
        //   createUser: 10,
        //   icon: "material/650000/20190926718214268542593.png",
        //   id: 10,
        //   name: "技术分享",
        //   routerName: "TechnologyShare",
        //   no: "Allmerchandise",
        //   pcUrl: "https://dev.gcw.net",
        //   remember_me: "",
        //   sort: 1,
        //   updateTime: 1566471530453,
        //   updateUser: 81,
        //   wapUrl: "https://wap.gcw.net"
        // }
      ],
      checked: "专业团队",
      mechanical: "专业团队",
      management: "企业管理",
      activeIndex: 0,
    }
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        this.checked = this.mechanical
      },
      deep: true
    },
    "$store.state.indexKey"(n, o) {
      this.indexKey = n
    }
  },
  methods: {
    linkGo(item) {
        this.$router.push(item.path)
    },
    // async getMenuList() {
    //   let res = await apiHome.getMenuList()
    //   this.menuList = res.data
    // }
  },
  created() {
    this.routerName = this.$route.name
    const indexKey = localStorage.read("indexKey")
      ? Number(localStorage.read("indexKey"))
      : -1

    this.indexKey = indexKey
    // this.getMenuList();
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";
@media screen and (min-width: 1218px) {
  .menu-box {
    .menu {
      width: 1200px;
    }
  }
}
@media screen and (max-width: 1217px) {
  .menu-box {
    .menu {
      width: 100%;
    }
  }
}

@media screen and (max-width: 992px) {
  .menu-box {
    .menu {
      width: 992px;
    }
  }
}
.menu-box {
  .menu {
    margin: 0 auto;
    height: 43px;
    font-size: 16px;
    color: $primary-gray-dark;
    clear: both;
    display: flex;
    justify-content: space-between;

    .inner {
      font-size: 18px;
      font-weight: bold;
      color:#333;
      height: 43px;
      line-height: 43px;
      text-align: center;
      float: left;
      //   flex: 1;
      width: 200px;
      &:hover {
        // color: #0286df;
        color: #b79255;
      }
      // padding-right: 30px;

      // &:nth-child(1) {
      //   padding-left: 20px;
      //   // width: 150px;
      //   // background: #0286df;
      //   // color: white;
      //   text-align: left;
      //   &:hover {
      //     // color: white;
      //   }
      //   img {
      //     margin-right: 5px;
      //   }
      // }
      // &:nth-child(2) {
      //   padding-left: 30px;
      // }
      // &:nth-child(3) {
      // }
    }
    .menu-click {
      // color: #0286df;
      // color: #B79255;
      color: #b79255;
      font-weight: bold;
      position: relative;
      &:before{
        content: '';
        position: absolute;
        margin-top: 20px;
        margin-left: -10px;
        background: #b79255;
        width: 4px;
        height: 4px;
      }
      .menu-dot {
        position: absolute;
        left: 20%;
        top: 20px;
        width: 4px;
        height: 4px;
        background: #0286df;
      }
      .homeMenuDot {
        left: 36%;
        left: 34%;
      }
    }
  }
  .menu-bottom {
    width: 100%;
    height: 15px;
    background: $primary-grey;
  }
}
</style>
